import { Text } from "@otrium/atoms";
import { Trans } from "@lingui/react";
import { CartWarning } from "src/atoms/CartWarning";
import { CloseWarningButton } from "./CheckoutWarning.styled";

type CheckoutWarningProps = {
  showWarning: boolean;
  errorMessage: string | null;
  onClose: () => void;
};

function CheckoutWarning({
  showWarning,
  errorMessage,
  onClose,
}: CheckoutWarningProps): JSX.Element {
  return (
    <CartWarning hidden={!showWarning}>
      <Text textAlign="left">
        <Trans id={errorMessage as string} />
      </Text>
      <CloseWarningButton onClick={onClose} iconSize="100%" />
    </CartWarning>
  );
}

export default CheckoutWarning;
